/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormBusinessTypeField_viewer$ref: FragmentReference;
declare export opaque type FormBusinessTypeField_viewer$fragmentType: FormBusinessTypeField_viewer$ref;
export type FormBusinessTypeField_viewer = {|
  +businessTypes: ?$ReadOnlyArray<?{|
    +id: string,
    +plainId: ?string,
    +name: ?string,
    +label: ?string,
  |}>,
  +$refType: FormBusinessTypeField_viewer$ref,
|};
export type FormBusinessTypeField_viewer$data = FormBusinessTypeField_viewer;
export type FormBusinessTypeField_viewer$key = {
  +$data?: FormBusinessTypeField_viewer$data,
  +$fragmentRefs: FormBusinessTypeField_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FormBusinessTypeField_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "businessTypes",
      "storageKey": null,
      "args": null,
      "concreteType": "BusinessType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "plainId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "label",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bd0885dce7d4c4fd06329d52d55dc3a9';
module.exports = node;
